import React, { useEffect, useState } from 'react';

import { FlashlightOff, FlashlightOn } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';

const STORAGE_KEY = 'usePromoNewForm';

const getUseNewPromoFormDefault = () => {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === null ? true : stored === 'true';
};

export const setUseNewPromoForm = (useNewForm: boolean) => {
  localStorage.setItem(STORAGE_KEY, String(useNewForm));
};

export const useNewPromoForm = () => {
  const [isDev, setIsDev] = useState(getUseNewPromoFormDefault);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, String(isDev));
  }, [isDev]);
  return isDev;
};

function PromoDevModeSwitch() {
  const [isDev, setIsDev] = useState(getUseNewPromoFormDefault);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, String(isDev));
  }, [isDev]);

  const handleSetDev = () => {
    const newValue = !isDev;
    setUseNewPromoForm(newValue);
    window.location.reload();
  };

  return (
    <Box>
      <Button
        variant="contained"
        onClick={handleSetDev}
        sx={{ padding: '0 16px', float: 'right' }}
        title={isDev ? '[new form]' : '[old form]'}
      >
        {isDev ? (
          <Typography>
            {' '}
            Legacy Promo Form
            <FlashlightOn />
          </Typography>
        ) : (
          <Typography>
            {' '}
            New Promo form
            <FlashlightOff />
          </Typography>
        )}
      </Button>
    </Box>
  );
}

export default PromoDevModeSwitch;
